import React, { FC } from "react";
import {
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  FormGroup,
  FormLabel,
  Grid,
  Tooltip,
  InputLabel,
} from "@mui/material";
import useStyles from "../../../components/common/model/styles";
import { FormFieldProps } from "../../../utils/formFields";

const FormMultiChipCheckbox: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  // Always an array of objects: [{id, name}]
  const selectedValues: any[] = props.value || [];

  const handleToggle = (option: any) => {
    let newValues = [...selectedValues];
    const exists = newValues.find((val) => val.id === option.id);

    if (exists) {
      newValues = newValues.filter((val) => val.id !== option.id);
    } else {
      newValues.push({ id: option.id, name: option.label });
    }

    props.onChange && props.onChange(newValues);
  };

  const renderChips = () => (
    <FormControl
      fullWidth
      sx={{ mt: 0, mb: 1 }}
      error={Boolean(props.error)}
      size="small"
    >
      <FormGroup row>
        {props.options?.map((option: any) => {
          const isChecked = selectedValues.some((val) => val.id === option.id);
          return (
            <Chip
              key={option.id}
              onClick={() => handleToggle(option)}
              label={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: isChecked ? "#004739" : "auto",
                  }}
                >
                  <Checkbox
                    size="small"
                    checked={isChecked}
                    style={{ padding: 0, marginRight: 6 }}
                  />
                  {option.label}
                </div>
              }
              variant={isChecked ? "filled" : "outlined"}
              sx={{ margin: "4px", background: isChecked ? "#CFCFCF" : "#fff" }}
            />
          );
        })}
      </FormGroup>
      {props.error && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );

  return (
    <>
      {props?.label && !props?.inSingleGridForm ? (
        <>
          <Grid item xs={12} sm={5} className={classes.labelBox}>
            <FormLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </FormLabel>
          </Grid>
          <Grid item xs={12} sm={7} style={{ padding: "0px" }}>
            {renderChips()}
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{
            display: "block",
            alignItems: "center",
            gap: 2,
            ...props?.GridFieldStyle,
          }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "left !important",
              }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Tooltip>
          {renderChips()}
        </Grid>
      ) : (
        renderChips()
      )}
    </>
  );
};

export default FormMultiChipCheckbox;
